import { Stack } from '@chakra-ui/react';

export default function VStack({ children, ...props }) {
  return <Stack {...props}>{children}</Stack>;
}
